(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["maahi-split-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.maahi-split-banner');
    if (!sections.length) return;

    const MAX_SCALE = 1.15;

    const update = () => {
      const vh = window.innerHeight;
      sections.forEach(section => {
        section.querySelectorAll('.maahi-split-banner__img').forEach(img => {
          const panel = img.closest('.maahi-split-banner__panel');
          const rect = panel.getBoundingClientRect();

          /* Progress 0 → 1 as the panel enters from below the viewport
             until its top reaches the top of the viewport. After the panel
             top is at or above the viewport top (rect.top <= 0), progress
             stays at 1 so the image stays at MAX while the user scrolls
             past into the footer. Scrolling back up reverses the zoom
             naturally as the panel re-enters the viewport from above. */
          let progress;
          if (rect.top <= 0) {
            progress = 1;
          } else if (rect.top >= vh) {
            progress = 0;
          } else {
            progress = (vh - rect.top) / vh;
          }

          const scale = 1 + progress * (MAX_SCALE - 1);
          img.style.transform = `scale(${scale.toFixed(4)})`;
        });
      });
    };

    let rafId = null;
    const schedule = () => {
      if (rafId) return;
      rafId = requestAnimationFrame(() => { update(); rafId = null; });
    };

    update();
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
